//

import { Button, Grid, TypographyProps } from "@mui/material";
import MxAlertCard from "./MxAlertCard";
import MxAlertIcon from "./MxAlertIcon";
import MxAlertTitleEvent from "./MxAlertTitleEvent";
import MxAlertMessage from "./MxAlertMessage";
import useModal from "../../../base/modal/useModal";
import MxButton from "@rf-l1/buttons/MxButton";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import MxCheck from "@rf-l1/form/MxCheck";
import { useState } from "react";

/**
 *
 *  This component is used to show an alert
 * @param type  type of alert only show type icon and title
 * @param message  message to show
 * @param color  color of alert this color prop affect  icon, title, buttons and shape colors
 * @param declineBtnMessage  message to show on decline button and conditional to render decline button
 * @param confirmBtnMessage  message to show on confirm button every time show confirm button, default is "Ok"
 * color accept color from theme, key path and hexadecimal
 * @example: color="primary.main" or color="#E68FAC" or color={theme.palette.error.main}
 */
export interface MxAlertProps {
  type: "success" | "error" | "warning" | "info" | "default" | "loading";
  color: TypographyProps["color"]; //
  message: string | React.ReactNode;
  declineBtnMessage?: string;
  confirmBtnMessage?: string;
  title?: string;
  hideButtons?: boolean;
  // Optional checkbox to include within the alert actions area
  checkLabel?: string; // if provided, renders a checkbox
  defaultChecked?: boolean; // initial state for the checkbox
}

function MxAlertTemplate(props: MxAlertProps) {
  const { type, color = "primary" } = props;
  const { onClose, onConfirm } = useModal();
  const [checkValue, setCheckValue] = useState<boolean>(
    Boolean(props.defaultChecked)
  );

  const title = {
    success: "¡Éxito!",
    error: "Oooops!",
    warning: "¡Alerta!",
    info: "¡Atención!",
    loading: "Cargando...",
    default: ""
  };

  return (
    <MxAlertCard color={color}>
      <Grid container item xs={12} rowGap={1.6}>
        <Grid container item xs={12} justifyContent={"center"}>
          <MxAlertIcon type={type} color={color} />
        </Grid>

        <Grid container item xs={12} justifyContent={"center"} mt={1}>
          <Grid item xs="auto">
            <MxAlertTitleEvent color={"grey.700"}>
              {props.title ? props.title : title[type]}
            </MxAlertTitleEvent>
          </Grid>
        </Grid>

        <Grid item xs={12} justifyContent={"center"}>
          <Grid item xs={12} mx={"auto"}>
            {typeof props.message === "string" ? (
              <MxAlertMessage>{props.message}</MxAlertMessage>
            ) : (
              props.message
            )}
          </Grid>
        </Grid>

        {props.checkLabel && (
          <Grid container item xs={12} justifyContent={"center"}>
            <MxCheck
              name="mx-alert-check"
              label={props.checkLabel}
              value={checkValue}
              onChange={e => setCheckValue(Boolean(e?.target?.value))}
            />
          </Grid>
        )}

        {!props.hideButtons && (
          <Grid container item xs={12}>
            {!!props.declineBtnMessage && (
              <Grid item xs={"auto"} mx={"auto"}>
                <MxButton2
                  onClick={() => onClose({ checkValue })}
                  variant="contained"
                  bgColor={"grey.300"}
                  textColor={"grey.700"}
                  testId="decline-button"
                  sx={{
                    minWidth: "100px"
                  }}
                >
                  {props.declineBtnMessage}
                </MxButton2>
              </Grid>
            )}
            <Grid item xs={"auto"} mx={"auto"}>
              <MxButton2
                onClick={() => onConfirm({ checkValue })}
                variant="contained"
                testId="confirm-button"
                sx={{
                  minWidth: "100px",
                  borderRadius: "50px",
                  borderColor: color,
                  color: "white",
                  boxShadow: "none",

                  backgroundColor: color,
                  fontWeight: 500,
                  fontSize: 12,
                  "&:hover": {
                    backgroundColor: color,
                    color: "white"
                  }
                }}
              >
                {props.confirmBtnMessage ?? "Ok"}
              </MxButton2>
            </Grid>
          </Grid>
        )}
      </Grid>
    </MxAlertCard>
  );
}

export default MxAlertTemplate;
